<template>
  <v-container class="pa-0">
    <input 
      ref="upload"
      id="fileUpload"
      type="file"
      accept="image/jpeg,image/png,image/webp"
      style="display:none"/>
    <v-sheet
      id="dropzone"
      ref="dzone"
      tabindex="0"
      title="Încarcă o imagine de pe dispozitiv"
      width="100%"
      rounded="lg"
      :class="['dropzone pa-5', { 'dropzone--active': dragover }]"
    >
      <v-icon color="indigo darken-2" size="48">
        {{ dragover ? 'mdi-tray-arrow-down' : 'mdi-cloud-upload-outline' }}
      </v-icon>
      <span class="dropzone__title indigo--text text--darken-2">
        {{ dragover ? 'Eliberează pentru a încărca' : 'Încarcă fotografia de profil' }}
      </span>
      <span v-if="!dragover" class="dropzone__hint grey--text text--darken-1">
        Trage imaginea aici sau apasă pentru a o selecta
      </span>
      <span v-if="!dragover" class="dropzone__hint grey--text text--darken-1">
        JPEG, PNG sau WebP, maximum 1 MB și 1024 × 1024 px
      </span>
    </v-sheet>

    <v-alert v-if="error" type="error" dense outlined class="mt-2 mb-0">
      {{ error }}
    </v-alert>

  </v-container>
</template>

<script>
  export default {
    data: () => {
      return {
        dragover: false,
        error: ''
      }
    },
    async mounted() {
      const dropzone = this.$el.querySelector("#dropzone")
      const fileupload = this.$el.querySelector("#fileUpload") // eslint-disable-line no-unused-vars
      if(dropzone) {
        // register all drag & drop event listeners
        dropzone.addEventListener("dragenter", e => {
          e.preventDefault()
          this.dragover = true
        })
        dropzone.addEventListener("dragleave", e => {
          e.preventDefault()
          this.dragover = false
        })
        dropzone.addEventListener("dragover", e => {
          e.preventDefault()
          this.dragover = true
        })
        dropzone.addEventListener("drop", e => {
          e.preventDefault()
          const dragevent = e
          if(dragevent.dataTransfer) {
            this.filesSelected(dragevent.dataTransfer.files) 
          }
        })
        dropzone.addEventListener("click", e => {
          e.preventDefault ()
          if(fileupload) {
            fileupload.click()
          }
        })
        dropzone.addEventListener("keypress", e => {
          e.preventDefault()
          const keyEvent = e
          if (keyEvent.key === "Enter") {
            if(fileupload) {
              fileupload.click()
            }
          }
        })
        // register listeners on the file input
        if(fileupload) {
          fileupload.addEventListener("change", e => {
            const target = (e.target)
            if(target.files) {
              this.filesSelected(target.files)
            }
          })
        }
      }
    },
    methods: {
      async filesSelected(fileList) {
        this.dragover = false
        this.error = ''

        const file = fileList && fileList[0]
        if (!file) return

        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
          this.error = 'Folosește o imagine JPEG, PNG sau WebP.'
          this.resetInput()
          return
        }

        if (file.size > 1024 * 1024) {
          this.error = 'Fotografia nu poate depăși 1 MB.'
          this.resetInput()
          return
        }

        const imageUrl = URL.createObjectURL(file)
        const dimensions = await new Promise(resolve => {
          const image = new Image()
          image.onload = () => resolve({width: image.naturalWidth, height: image.naturalHeight})
          image.onerror = () => resolve(null)
          image.src = imageUrl
        })
        URL.revokeObjectURL(imageUrl)

        if (!dimensions) {
          this.error = 'Imaginea selectată nu poate fi citită.'
          this.resetInput()
          return
        }

        if (dimensions.width > 1024 || dimensions.height > 1024) {
          this.error = 'Fotografia nu poate depăși 1024 × 1024 px.'
          this.resetInput()
          return
        }

        this.$emit('filesSelected', [file])
        this.resetInput()
      },
      resetInput() {
        if (this.$refs.upload) {
          this.$refs.upload.value = ''
        }
      }
    }
  }
</script>

<style scoped>
.dropzone {
  min-height: 150px;
  border: 2px dashed rgba(48, 63, 159, 0.45);
  background-color: rgba(197, 202, 233, 0.55) !important;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  transition: background-color 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.dropzone:hover,
.dropzone:focus-visible,
.dropzone--active {
  border-color: #3f51b5;
  background-color: rgba(159, 168, 218, 0.45) !important;
  outline: none;
}

.dropzone--active {
  transform: scale(1.01);
}

.dropzone__title {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
}

.dropzone__hint {
  max-width: 280px;
  font-size: 0.8rem;
  line-height: 1.35;
}
</style>
